<template>
  <v-btn
    :class="
      classP +
        (primary ? ' v-btn-primary ' : '') +
        (sutartis ? ' btn-sutartis ' : '')
    "
    :color="color"
    :disabled="disabled"
    :loading="loading"
    :small="small"
    :x-small="xSmall"
    ><slot
  /></v-btn>
</template>

<script>
export default {
  name: 'ElButton',
  props: {
    classP: String,
    color: String,
    disabled: Boolean,
    loading: Boolean,
    primary: Boolean,
    sutartis: Boolean,
    small: Boolean,
    xSmall: Boolean,
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/elementsTheme.scss';
.btn-sutartis {
  background-color: $sutartis !important;
  border-color: $sutartis !important;
  color: $white !important;
}
.btn-sutartis:hover,
.btn-sutartis:focus,
.btn-sutartis:focus-within,
.btn-sutartis:active {
  background-color: $sutartisHover !important;
  color: $white !important;
  border: $sutartisHover solid 0.1rem !important;
  outline: none;
}
</style>
